/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { City } from '@app/settings/cities/cities.model';
import { CitiesFormComponent } from '@app/settings/cities/cities-form/cities-form.component';
import { Country } from '@app/settings/countries/countries.model';

@Injectable({
  providedIn: 'root',
})
export class CitiesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open city form
   * @param city Dialog data
   * @param country Populated country
   */
  public open(city: null | City = null, country?: Country): Promise<any> {
    const modal = this.modalService.open(CitiesFormComponent, { size: 'lg' });
    modal.componentInstance.city = city;
    modal.componentInstance.country = country;
    return modal.result;
  }
}
